//Пример в яндекс песочнице
//https://tech.yandex.ru/maps/jsbox/2.1/balloon_autopan

function map(id, lat, lon) {

    if ( $('#'+id).length ) {

        // устанавливает высоту блока с картой в зависимости от контента
        if( $('.map-content').length ) {
            var contentHeight = $('.map-content').outerHeight();
            $('.map-container').height(contentHeight + 100);
        }

        ymaps.ready(function () {
            var map = new ymaps.Map(id, {
                    center: [lat, lon],
                    zoom: 9,
                    controls: []
                }),
                balloonLayout = ymaps.templateLayoutFactory.createClass(
                    `<div class="map-popup">
                        <div class="map-popup__inner">
                            <button type="button" class="map-popup__close _js-close-popup">
                            <svg class="i _close"><use xlink:href="#close"/></svg>
                            </button> $[[options.contentLayout observeSize  minWidth=235 maxWidth=235 maxHeight=350]]</div>
                    </div>`, {
                        /**
                         * Строит экземпляр макета на основе шаблона и добавляет его в родительский HTML-элемент.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#build
                         * @function
                         * @name build
                         */
                        build: function () {
                            this.constructor.superclass.build.call(this);
                            this._$element = $('.map-popup', this.getParentElement());
                            this.applyElementOffset();
                            this._$element.find('._js-close-popup')
                                .on('click', $.proxy(this.onCloseClick, this));
                        },

                        /**
                         * Удаляет содержимое макета из DOM.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#clear
                         * @function
                         * @name clear
                         */
                        clear: function () {
                            this._$element.find('._js-close-popup')
                                .off('click');

                            this.constructor.superclass.clear.call(this);
                        },
                        /**
                         * Метод будет вызван системой шаблонов АПИ при изменении размеров вложенного макета.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                         * @function
                         * @name onSublayoutSizeChange
                         */
                        onSublayoutSizeChange: function () {
                            balloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                            if(!this._isElement(this._$element)) {
                                return;
                            }

                            this.applyElementOffset();

                            this.events.fire('shapechange');
                        },

                        /**
                         * Сдвигаем балун, чтобы "хвостик" указывал на точку привязки.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                         * @function
                         * @name applyElementOffset
                         */
                        applyElementOffset: function () {
                            this._$element.css({
                                left: -(this._$element[0].offsetWidth / 2),
                                top: -(this._$element[0].offsetHeight)
                                //top: -(this._$element[0].offsetHeight + this._$element.find('.arrow')[0].offsetHeight)
                            });
                        },

                        /**
                         * Закрывает балун при клике на крестик, кидая событие "userclose" на макете.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                         * @function
                         * @name onCloseClick
                         */
                        onCloseClick: function (e) {
                            e.preventDefault();

                            this.events.fire('userclose');
                        },

                        /**
                         * Используется для автопозиционирования (balloonAutoPan).
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/ILayout.xml#getClientBounds
                         * @function
                         * @name getClientBounds
                         * @returns {Number[][]} Координаты левого верхнего и правого нижнего углов шаблона относительно точки привязки.
                         */
                        getShape: function () {
                            if(!this._isElement(this._$element)) {
                                return balloonLayout.superclass.getShape.call(this);
                            }

                            var position = this._$element.position();

                            return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                                [position.left, position.top], [
                                    position.left + this._$element[0].offsetWidth,
                                    position.top + this._$element[0].offsetHeight
                                    //position.top + this._$element[0].offsetHeight + this._$element.find('.arrow')[0].offsetHeight
                                ]

                            ]));
                        },

                        /**
                         * Проверяем наличие элемента (в ИЕ и Опере его еще может не быть).
                         * @function
                         * @private
                         * @name _isElement
                         * @param {jQuery} [element] Элемент.
                         * @returns {Boolean} Флаг наличия.
                         */
                        _isElement: function (element) {
                            //return element && element[0] && element.find('.arrow')[0];
                            return element && element[0];
                        }
                    }),

                // Создание вложенного макета содержимого балуна.
                balloonLayoutContent = ymaps.templateLayoutFactory.createClass(
                    '<h5 class="map-popup__heading">$[properties.balloonHeader]</h5>' +
                    '<p class="map-popup__text">$[properties.balloonContent]</p>' +
                    '<p class="map-popup__text"><a href="tel:$[properties.balloonPhone]">$[properties.balloonPhone]</a></p>' +
                    '<p class="map-popup__text"><a href="mailto:$[properties.balloonEmail]">$[properties.balloonEmail]</a></p>'
                ),

                // Создание метки с пользовательским макетом балуна.
                placemark = window.placemark = new ymaps.Placemark(map.getCenter(), {
                    balloonHeader: 'г. Нижний Новгород, ул. Родионова, д.27, эт.2',
                    balloonContent: 'ООО «Центр оценки квалификации» №678675',
                    balloonPhone: '8 (875) 777-88-99',
                    balloonEmail: 'emailname@gmail.com'
                },{
                    balloonShadow: false,
                    balloonLayout: balloonLayout,
                    balloonContentLayout: balloonLayoutContent,
                    balloonPanelMaxMapArea: 0,
                    iconLayout: 'default#image',
                    iconImageHref: 'assets/svg_icons/map-marker.svg',
                    iconImageSize: [46, 36],
                    iconImageOffset: [-23, -36]
                });

            map.geoObjects.add(placemark);

            map.controls.add('zoomControl', {
                position: {
                    right: '20px',
                    top: '108px;'
                }
            });

            // Проверка на устройство на котором открыта страница.
            var isMobile = {
                Android: function () {
                    return navigator.userAgent.match(/Android/i);
                },
                BlackBerry: function () {
                    return navigator.userAgent.match(/BlackBerry/i);
                },
                iOS: function () {
                    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
                },
                Opera: function () {
                    return navigator.userAgent.match(/Opera Mini/i);
                },
                Windows: function () {
                    return navigator.userAgent.match(/IEMobile/i);
                },
                any: function () {
                    return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
                }
            }

            if (isMobile.any()) {
                map.behaviors.disable('drag');

                //disable map scroll on mobile devices
                $(document.body).on('scroll', function() {
                    map.behaviors.disable('drag');
                });
            }

            //блокировка/разблокировка карты
            $(document).on('click',function (e) {
                var el = '.map-container';
                // console.log($(e.target), $(e.target).closest(el).length);
                if (isMobile.any()){
                    if ($(e.target).closest(el).length) {
                        map.behaviors.enable('drag');
                    } else {
                        map.behaviors.disable('drag');
                    }
                }
            });
        });
    }
}

//Пример в яндекс песочнице
//https://tech.yandex.ru/maps/jsbox/2.1/balloon_autopan

function mapRoute(id, lat, lon) {

    if ( $('#'+id).length ) {

        // устанавливает высоту блока с картой в зависимости от контента
        if( $('.map-content').length ) {
            var contentHeight = $('.map-content').outerHeight();
            $('.map-container').height(contentHeight + 100);
        }

        ymaps.ready(function () {
            var map = new ymaps.Map(id, {
                    center: [lat, lon],
                    zoom: 9,
                    controls: ['routePanelControl']
                }),
                balloonLayout = ymaps.templateLayoutFactory.createClass(
                    `<div class="map-popup">
                        <div class="map-popup__inner">
                            <button type="button" class="map-popup__close _js-close-popup">
                            <svg class="i _close"><use xlink:href="#close"/></svg>
                            </button> $[[options.contentLayout observeSize  minWidth=235 maxWidth=235 maxHeight=350]]</div>
                    </div>`, {
                        /**
                         * Строит экземпляр макета на основе шаблона и добавляет его в родительский HTML-элемент.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#build
                         * @function
                         * @name build
                         */
                        build: function () {
                            this.constructor.superclass.build.call(this);
                            this._$element = $('.map-popup', this.getParentElement());
                            this.applyElementOffset();
                            this._$element.find('._js-close-popup')
                                .on('click', $.proxy(this.onCloseClick, this));
                        },

                        /**
                         * Удаляет содержимое макета из DOM.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#clear
                         * @function
                         * @name clear
                         */
                        clear: function () {
                            this._$element.find('._js-close-popup')
                                .off('click');

                            this.constructor.superclass.clear.call(this);
                        },
                        /**
                         * Метод будет вызван системой шаблонов АПИ при изменении размеров вложенного макета.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                         * @function
                         * @name onSublayoutSizeChange
                         */
                        onSublayoutSizeChange: function () {
                            balloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                            if(!this._isElement(this._$element)) {
                                return;
                            }

                            this.applyElementOffset();

                            this.events.fire('shapechange');
                        },

                        /**
                         * Сдвигаем балун, чтобы "хвостик" указывал на точку привязки.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                         * @function
                         * @name applyElementOffset
                         */
                        applyElementOffset: function () {
                            this._$element.css({
                                left: -(this._$element[0].offsetWidth / 2),
                                top: -(this._$element[0].offsetHeight)
                                //top: -(this._$element[0].offsetHeight + this._$element.find('.arrow')[0].offsetHeight)
                            });
                        },

                        /**
                         * Закрывает балун при клике на крестик, кидая событие "userclose" на макете.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                         * @function
                         * @name onCloseClick
                         */
                        onCloseClick: function (e) {
                            e.preventDefault();

                            this.events.fire('userclose');
                        },

                        /**
                         * Используется для автопозиционирования (balloonAutoPan).
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/ILayout.xml#getClientBounds
                         * @function
                         * @name getClientBounds
                         * @returns {Number[][]} Координаты левого верхнего и правого нижнего углов шаблона относительно точки привязки.
                         */
                        getShape: function () {
                            if (!this._isElement(this._$element)) {
                                return balloonLayout.superclass.getShape.call(this);
                            }

                            var position = this._$element.position();

                            return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                                [position.left, position.top], [
                                    position.left + this._$element[0].offsetWidth,
                                    position.top + this._$element[0].offsetHeight
                                    //position.top + this._$element[0].offsetHeight + this._$element.find('.arrow')[0].offsetHeight
                                ]

                            ]));
                        },

                        /**
                         * Проверяем наличие элемента (в ИЕ и Опере его еще может не быть).
                         * @function
                         * @private
                         * @name _isElement
                         * @param {jQuery} [element] Элемент.
                         * @returns {Boolean} Флаг наличия.
                         */
                        _isElement: function (element) {
                            //return element && element[0] && element.find('.arrow')[0];
                            return element && element[0];
                        }
                    }),

                // Создание вложенного макета содержимого балуна.
                balloonLayoutContent = ymaps.templateLayoutFactory.createClass(
                    '<h5 class="map-popup__heading">$[properties.balloonHeader]</h5>' +
                    '<p class="map-popup__text">$[properties.balloonContent]</p>' +
                    '<p class="map-popup__text"><a href="tel:$[properties.balloonPhone]">$[properties.balloonPhone]</a></p>' +
                    '<p class="map-popup__text"><a href="mailto:$[properties.balloonEmail]">$[properties.balloonEmail]</a></p>'
                ),

                // Создание метки с пользовательским макетом балуна.
                placemark = new ymaps.Placemark(map.getCenter(), {
                    balloonHeader: 'г. Нижний Новгород, ул. Родионова, д.27, эт.2',
                    balloonContent: 'ООО «Центр оценки квалификации» №678675',
                    balloonPhone: '8 (875) 777-88-99',
                    balloonEmail: 'emailname@gmail.com'
                }, {
                    balloonShadow: false,
                    balloonLayout: balloonLayout,
                    balloonContentLayout: balloonLayoutContent,
                    balloonPanelMaxMapArea: 0,
                    iconLayout: 'default#image',
                    iconImageHref: 'assets/svg_icons/map-marker.svg',
                    iconImageSize: [46, 36],
                    iconImageOffset: [-23, -36]
                });

            var multiRoute;
            var control = map.controls.get('routePanelControl');

            control.routePanel.state.set({
                type: 'masstransit',
                fromEnabled: true,
                toEnabled: false,
            });

            placemark.events.add('balloonopen', function (e) {
                control.routePanel.state.set({
                    to: placemark.geometry.getCoordinates()
                });

                control.routePanel.options.set({
                    allowSwitch: false,
                    reverseGeocoding: true,
                    types: { masstransit: true, pedestrian: true, taxi: true }
                });

            });

            // map.geoObjects.add(multiRoute);
            map.geoObjects.add(placemark);

            map.controls.add('zoomControl', {
                position: {
                    right: '20px',
                    top: '108px;'
                }
            });

            // Проверка на устройство на котором открыта страница.
            var isMobile = {
                Android: function () {
                    return navigator.userAgent.match(/Android/i);
                },
                BlackBerry: function () {
                    return navigator.userAgent.match(/BlackBerry/i);
                },
                iOS: function () {
                    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
                },
                Opera: function () {
                    return navigator.userAgent.match(/Opera Mini/i);
                },
                Windows: function () {
                    return navigator.userAgent.match(/IEMobile/i);
                },
                any: function () {
                    return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
                }
            }

            if (isMobile.any()) {
                map.behaviors.disable('drag');

                //disable map scroll on mobile devices
                $(document.body).on('scroll', function() {
                    map.behaviors.disable('drag');
                });
            }

            //блокировка/разблокировка карты
            $(document).on('click',function (e) {
                var el = '.map-container';

                if (isMobile.any()){
                    if ($(e.target).closest(el).length) {
                        map.behaviors.enable('drag');
                    } else {
                        map.behaviors.disable('drag');
                    }
                }
            });
        });
    }
}
